<template>
    <div class="header-analytics-perfection">
        <span class="header-analytics-perfection__ornament-top"></span>
        <span class="header-analytics-perfection__h1">Kusursuzluk Analitikleri</span>
        <span class="header-analytics-perfection__ornament-bot"></span>
    </div>
</template>
<script>
    export default {};
</script>
<style scoped src="@/css/components/header-analytics-perfection.css"></style>
